export const PendingChangesOperationGroupTestIds = {
  GROUP: 'pending-changes-operation-group.container',
  META: 'pending-changes-operation-group.meta',
  AFFECTED_TOGGLE: 'pending-changes-operation-group.affected-toggle',
  AFFECTED_LIST: 'pending-changes-operation-group.affected-list',
};
